<template>
  <simple-activity :show-header="false">
    <b-container fluid class="justify-content-start mt-3">
      <b-row class="m-0">
        <b-col class="m-0">
          <b-row class="justify-content-center">

            <!-- PHOTO COLUMN -->
            <b-col class="col-xl-6 col-12 mt-3 text-center justify-content-center order-2 order-xl-1"
                   data-test-path="image-card">
              <v-box style="display: flex; justify-content: center; width: 100%; height: 100%">
                <div style="height: 100%; width: 100%; display: flex; justify-content: center;">
                  <img
                      v-if="image && !generating && !nothingFound"
                      :src="image"
                      alt="ai-image"
                      ref="ai-image"
                      style="max-width: 100%; max-height: 60vh; object-fit: contain">
                  <b-card
                      v-else-if="!image && !generating && !nothingFound"
                      class="card-image"
                      style="height: 60vh; width: 40vw; min-height: 450px"
                  >
                    <b-card-body class="d-flex flex-column align-items-center card-body" style="margin-top: 100px">
                      <img src="https://silkplm.com/wp-content/uploads/2024/12/Generate-image.png" alt="generate photo">
                      <div class="text-left">
                        <ul style="list-style-type: decimal; font-size: 20px; font-weight: bold; margin-top: 15px">
                          <li>{{ $tr('selectOption', 'Select Option') }}</li>
                          <li>{{ $tr('typeDesc', 'Type a short description') }}</li>
                          <li>{{ $tr('generateIns', 'Generate your inspiration') }}</li>
                        </ul>
                      </div>
                    </b-card-body>
                  </b-card>
                  <b-card
                      v-else-if="generating && !nothingFound"
                      class="card-image"
                      style="height: 60vh; width: 40vw"
                  >
                    <div class="d-flex justify-content-center" style="position: relative; top: 30%">
                      <h3>{{ $tr('generating', 'Generating') }}</h3>
                      <font-awesome-icon
                          :icon="['fad', 'spinner-third']"
                          spin
                          size="2xl"
                          style="--fa-primary-color: #3584e4; --fa-secondary-color: #3584e4;"
                          class="ml-4 mt-2"/>
                    </div>
                  </b-card>
                  <b-card
                      v-else
                      class="card-image"
                      style="height: 60vh; width: 40vw"
                  >
                    <div class="d-flex justify-content-center" style="position: relative; top: 50%">
                      <h1>
                        {{
                          $tr('noImageGenerated', 'Could not generate an image. Check your search parameters and try again.')
                        }}</h1>
                    </div>
                  </b-card>
                </div>
              </v-box>
            </b-col>

            <!-- SETTINGS COLUMN -->
            <b-col class="col-xl-6 col-12 text-left order-1 order-xl-2 mt-3">
              <b-container style="margin-top:30px">

                <!-- TITLE -->
                <b-row class="pb-3">
                  <b-col class="text-left">
                    <h2 style="font-weight: bold; color: #4B5568;"
                        v-text="$tr('ai-product-generator-settings', 'Choose Settings')"></h2>
                  </b-col>
                </b-row>


                <!-- CHECKBOXES WITH FASHION TECHNIC -->

                <!--           CHECKBOX WITH MODEL           -->
                <!--                    <form class="mt-3 form-inline d-flex justify-content-center">-->
                <!--                      <b-form-checkbox-->
                <!--                          id="checkbox-1"-->
                <!--                          v-model="withModel"-->
                <!--                          checked="true"-->
                <!--                          unchecked-value="false"-->
                <!--                          name="checkbox-1">-->
                <!--                      </b-form-checkbox>-->
                <!--                      <label class="mr-3">{{ $tr('ai-product-generator-with-model', 'With Model') }}</label>-->
                <!--                    </form>-->
                <!--                  </b-col>-->

                <b-row class="pb-3">
                  <b-col>
                    <form class="mt-3 d-flex justify-content-start">
                      <div class="d-flex flex-column">
                        <label class="mr-3 mb-1 text-left" style="font-weight: bold">{{
                            $tr('ai-product-generator-type-of-product', 'Type of Product:')
                          }}</label>
                        <b-button-group size="sm" class="mt-1" data-test-path="type-of-product">
                          <b-button
                              v-for="option in productOptions"
                              :key="option.value"
                              :class="typeOfProduct !== option.value ? 'selected-btn' : 'unselected-btn'"
                              @click="typeOfProduct = option.value"
                              style="padding: 10px 20px"
                          >
                            {{ option.text }}
                          </b-button>
                        </b-button-group>
                      </div>
                    </form>
                  </b-col>
                </b-row>

                <!-- CHECKBOXES WITH TECHNIC HOME DECOR -->
                <b-row class="pb-3 d-flex flex-column justify-content-start col mt-3"
                       v-if="typeOfProduct === 'Home Decor'">
                  <label class="mr-3 mb-1 text-left" style="font-weight: bold">{{
                      $tr('ai-product-generator-style', 'Style:')
                    }}</label>
                  <div class="text-left">
                    <b-form-group
                        :text="$tr('ai-generator-technic-text', 'Technic')"
                        v-slot="{ ariaDescribedby }">
                      <b-form-radio-group
                          id="btn-radios-1"
                          v-model="selectedTechnic"
                          :options="technicOptions"
                          :aria-describedby="ariaDescribedby"
                          name="radios-btn-default"
                          class="checkbox-group"
                          buttons
                      ></b-form-radio-group>
                    </b-form-group>
                  </div>
                </b-row>
                <div v-if="typeOfProduct === 'Jewelry'"
                     class="d-flex flex-column justify-content-start area-product mb-2"
                     style="border-radius: 5px; background-color: #EDF4FC; width: 390px">
                  <label class="mr-3 px-2 pb-1 mt-1 text-left" style="font-weight: bold">{{
                      $tr('ai-product-generator-type-of-jewelry', 'Type of jewelry:')
                    }}</label>
                  <div class="d-flex justify-content-start px-2 mb-3">
                    <b-form-group class="w-100">
                      <b-form-select
                          v-model="jewelry"
                          ref="jewelryInput"
                          @change="jewelryRefresh"
                          :options="jewelryOptions">
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <label class="mr-3 px-2 pb-1 mt-1 text-left" style="font-weight: bold">{{
                      $tr('ai-product-generator-target-gender', 'Target gender:')
                    }}</label>
                  <div class="d-flex justify-content-start px-2 mb-3">
                    <b-form-group class="w-100">
                      <b-form-select
                          v-model="jewelryTargetGender"
                          ref="jewelryTargetGenderInput"
                          @change="jewelryTargetGenderRefresh"
                          :options="genderOptions">
                      </b-form-select>
                    </b-form-group>
                  </div>
                </div>

                <!--           SELECT TYPE OF PRODUCT          -->
                <div
                     class="d-flex flex-column justify-content-start area-product"
                     style="border-radius: 5px; background-color: #EDF4FC; width: 390px">
                  <label class="mr-3 px-2 pb-1 mt-1 text-left" style="font-weight: bold">{{
                      $tr('ai-product-generator-description', 'Description:')
                    }}</label>
                  <div class="d-flex justify-content-start px-2 mb-3">
                    <b-form-textarea
                        id="input"
                        style="max-width: 100%;"
                        v-model="input"
                        :placeholder="$tr('ai-product-generator-placeholder2', 'Describe product or pattern. Example: Polo Cotton T-shirt with White Collar; Blue flowers on green background, cartoon style')"
                        rows="4"
                        max-rows="6">
                    </b-form-textarea>
                  </div>
                </div>
                <!-- TEXT AREA -->

                <b-row v-if="noText" class="d-flex justify-content-center">
                  <p class="text-danger">{{ $tr("AI-no-text", "The description is too short. Min 3 characters") }}</p>
                </b-row>

                <!-- GENERATE AND DOWNLOAD BUTTONS -->
                <b-row>
                  <div>
                    <div class="mt-3 d-flex justify-content-start">
                      <FooterButton
                          type="Generate"
                          @generate="generate"
                          variant="plm-success"
                          :disabled="!input || (!selectedTechnic && typeOfProduct !== 'Fabric pattern') || generating || !typeOfProduct || (typeOfProduct === 'Jewelry' && (!jewelryTargetGender || !jewelry))">
                      </FooterButton>
                      <div v-if="image && !generating">
                        <a :href="image" :download="getFileName(image)" style="text-decoration: none">
                          <b-button
                              data-test-path="download-button"
                              variant="plm-primary-light"
                              class="size-button"
                              @click.stop="clickOnButton"
                              target="_blank"
                          >
                            <font-awesome-icon icon="download"/>
                            <label ref="label" class="d-none d-md-inline pl-1">{{
                                $tr("savePhoto", "Save photo")
                              }}</label>
                          </b-button>
                        </a>
                      </div>
                    </div>
                  </div>
                </b-row>

                <b-row v-if="generating" class="mt-3">
                  <b-col>
                    <h4>{{ $tr('takeWhile', 'This may take a while (Approx. 15-20s)') }}</h4>
                  </b-col>
                </b-row>

              </b-container>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:footer>
      <footer-button type="Cancel" @cancel="close" v-if="closeMode"></footer-button>
      <footer-button :disabled="generating || !image" type="Select" @select="select" v-if="selectMode"></footer-button>
    </template>
  </simple-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity.vue";
import FooterButton from "@/components/navbar/FooterButton.vue";
import CloseButton from "@/components/navbar/CloseButton.vue";
import FooterNavbar from "@/components/navbar/FooterNavbar.vue";
import SlideShow from "@/components/img/SlideShow.vue";
import VBox from "@/components/VBox.vue";
import DownloadButton from "@/components/navbar/DownloadButton.vue";
import PantoneRenderer from "@/components/forms/renderers/PantoneRenderer.vue";
import Rpc from "@/Rpc";
import {sendEvent} from "@/utils/GEvents";
import DialogManager from "@/utils/DialogManager";


export default {
  name: "AIProductGenerator",
  components: {
    DownloadButton,
    VBox,
    FooterNavbar,
    SlideShow,
    CloseButton,
    FooterButton,
    SimpleActivity,
    PantoneRenderer
  },

  computed: {
    columnClass() {
      return this.typeOfProduct === 'Fashion' ? 'col-6 pr-5' : 'col-12';
    }
  },

  async mounted() {
    if (this.typeOfProduct === 'Fashion') {
      this.selectedTechnic = 'With Model #1';
    } else {
      this.selectedTechnic = 'Photo Realistic';
    }
  },

  methods: {
    ...Activity.methods,

    select() {
      this.setResult({
        image: this.file,
        description: this.input
      })
      this.close();
    },

    sizeChanged(height) {
      this.imgH = height;
    },

    getFileName(url) {
      return url.split('/').pop();
    },

    getTitle() {
      return 'AI Photo Generator';
    },

    clickOnButton() {
      this.$emit("download");
    },

    cancel() {
      this.setResult(null);
      this.close();
    },

    async generate() {

      this.nothingFound = false;
      if (this.input.length >= 3) {
        this.noText = false;
        this.generating = true;
        try {
          let type = this.typeOfProduct;
          sendEvent("ai-gen-" + type, {});
          let task = await Rpc.ai.GenerateImageByAI.generateProduct(this.selectedTechnic, this.withModel, this.input, this.typeOfProduct, this.aiProps);
          if (type === "Fabric pattern") {
            let data = await task.finish();
            this.file = data;
            this.image = this.file.url;
          } else {
            this.file = await task.finish();
            this.image = this.file.url;
          }
        } catch (e) {
          this.nothingFound = true;
        } finally {
          this.generating = false;
        }
      } else {
        this.noText = true;
      }
    },

    jewelryRefresh() {
      this.jewelry = this.$refs.jewelryInput.$el.value;
      this.aiProps["type"] = this.jewelry;
    },

    jewelryTargetGenderRefresh(){
      this.jewelryTargetGender = this.$refs.jewelryTargetGenderInput.$el.value;
      this.aiProps["gender"] = this.jewelryTargetGender;
    }
  },

  watch: {
    typeOfProduct(newVal) {
      // localStorage.setItem('typeOfProduct', newVal);
      if (this.typeOfProduct === 'Fashion') {
        this.selectedTechnic = 'With Model #1';
      } else {
        this.selectedTechnic = 'Photo Realistic';
      }
    },
  },

  props: {
    closeMode: {default: false},
    selectMode: {default: false}
  },

  data: function () {
    return {
      imgH: window.height,
      image: null,
      file: null,
      jewelry: "",
      jewelryTargetGender: "",
      jewelryOptions: ["bag", "shoes", "necklace", "bracelet", "earrings", "watch", "ring", "sunglasses"],
      genderOptions: ["man", "woman"],
      aiProps: {},
      // typeOfProduct: localStorage.getItem('typeOfProduct') || 'Fashion',
      typeOfProduct: 'Fashion',
      productOptions: [
        {text: $tr('ai-product-generator-fashion', 'Fashion'), value: 'Fashion'},
        {text: $tr('ai-product-generator-home-decor', 'Home Decor'), value: 'Home Decor'},
        {text: $tr('ai-product-generator-pattern', 'Fabric Pattern'), value: 'Fabric pattern'},
        {text: $tr('ai-product-generator-accessories', 'Accessories'), value: 'Jewelry'},
      ],
      noImg: 'https://silkplm.com/wp-content/uploads/2025/01/placeholder-image.png',
      selectedTechnic: '',
      technicOptions: [
        {text: $tr('technic-sketch', 'Sketch'), value: 'Sketch'},
        {text: $tr('technic-colored-sketch', 'Colored Sketch'), value: 'Colored Sketch'},
        {text: $tr('technic-photo-realistic', 'Photo Realistic'), value: 'Photo Realistic'},
      ],
      technicFashionOptions: [
        // {text: $tr('technic-fashion-without-model', 'Without Model'), value: 'Without Model'},
        {text: $tr('technic-fashion-1', 'With Model #1'), value: 'With Model #1'},
        {text: $tr('technic-fashion-2', 'With Model #2'), value: 'With Model #2'},
      ],
      withModel: false,
      input: '',
      generating: false,
      noText: false,
      nothingFound: false,
    }
  }
}
</script>

<style>
.card-image {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed #C6E0F2;
}

.checkbox-group .btn {
  border-radius: 5px;
  background-color: #4D7A98;
  padding: 10px 20px;
}

.checkbox-group .btn:hover {
  background-color: #253D5A;
}

.checkbox-group .btn.btn-secondary.active {
  background-color: #253D5A;
}

.selected-btn {
  background-color: #4D7A98;
}

.selected-btn:hover {
  background-color: #253D5A;
}

.unselected-btn {
  background-color: #253D5A;
}

.unselected-btn:hover {
  background-color: #253D5A;
}

@media screen and (max-width: 1200px) {
  .card-image {
    width: 70vw !important;
  }

}

@media screen and (max-width: 450px) {
  .area-product {
    width: 90% !important;
  }

}

@media screen and (max-height: 780px) {
  .card-body {
    margin-top: 10px !important;
  }
}

</style>
